import React, { useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { CommonOption, SearchableDropdownProps } from '../types/common.types';
import { sortOptionsByLabel } from '../utils/sortOptions';

const SearchableDropdown: React.FC<SearchableDropdownProps> = ({
  label,
  value,
  options,
  onChange,
  placeholder = 'Search and select',
  disabled = false,
  loading = false,
  fullWidth = true,
}) => {
  const sortedOptions = useMemo(() => sortOptionsByLabel(options), [options]);

  return (
    <Autocomplete
      options={sortedOptions}
      value={value}
      onChange={(_, selectedValue: CommonOption | null) => onChange(selectedValue)}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, selectedValue) => option.value === selectedValue.value}
      loading={loading}
      disabled={disabled}
      fullWidth={fullWidth}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          size="small"
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  );
};

export default SearchableDropdown;
